import * as Joi from 'joi';
import _ from 'lodash';
import { CLIENT_STATE_KEYS, CLIENT_STATE_VERSIONS, } from '../../client-state-type';
import { ClientStateV2Class, ClientStateV2Schema } from '../types/v2';
var DEPRECATED_CHART_RESPONSIVE_LAYOUT;
(function (DEPRECATED_CHART_RESPONSIVE_LAYOUT) {
    DEPRECATED_CHART_RESPONSIVE_LAYOUT[DEPRECATED_CHART_RESPONSIVE_LAYOUT["USER_PREFERRED_ON"] = 1] = "USER_PREFERRED_ON";
    DEPRECATED_CHART_RESPONSIVE_LAYOUT[DEPRECATED_CHART_RESPONSIVE_LAYOUT["USER_PREFERRED_OFF"] = 2] = "USER_PREFERRED_OFF";
    DEPRECATED_CHART_RESPONSIVE_LAYOUT[DEPRECATED_CHART_RESPONSIVE_LAYOUT["AUTO_ON"] = 3] = "AUTO_ON";
    DEPRECATED_CHART_RESPONSIVE_LAYOUT[DEPRECATED_CHART_RESPONSIVE_LAYOUT["AUTO_OFF"] = 4] = "AUTO_OFF";
})(DEPRECATED_CHART_RESPONSIVE_LAYOUT || (DEPRECATED_CHART_RESPONSIVE_LAYOUT = {}));
const upgradeV2dot1toV2dot2 = (clientState, vizModel) => {
    const updatedClientState = _.cloneDeep(clientState);
    const chartProperties = _.get(clientState, CLIENT_STATE_KEYS.chartProperties) || {};
    const responsiveLayoutDisabled = chartProperties[CLIENT_STATE_KEYS.responsiveLayoutDisabled];
    let responsiveLayoutPreference;
    if (responsiveLayoutDisabled === true) {
        responsiveLayoutPreference =
            DEPRECATED_CHART_RESPONSIVE_LAYOUT.USER_PREFERRED_OFF;
    }
    else if (responsiveLayoutDisabled === false) {
        responsiveLayoutPreference =
            DEPRECATED_CHART_RESPONSIVE_LAYOUT.USER_PREFERRED_ON;
    }
    else {
        responsiveLayoutPreference =
            DEPRECATED_CHART_RESPONSIVE_LAYOUT.USER_PREFERRED_ON;
    }
    delete chartProperties[CLIENT_STATE_KEYS.responsiveLayoutDisabled];
    chartProperties[CLIENT_STATE_KEYS.responsiveLayoutPreference] = responsiveLayoutPreference;
    const newClientState = {
        ...updatedClientState,
        [CLIENT_STATE_KEYS.chartProperties]: chartProperties,
        [CLIENT_STATE_KEYS.version]: CLIENT_STATE_VERSIONS.V2dot2,
    };
    const clientStateV2 = new ClientStateV2Class();
    _.assign(clientStateV2, newClientState);
    return clientStateV2;
};
const upgraderFn = (clientState, vizModel) => {
    Joi.assert(clientState, ClientStateV2Schema);
    const clientStateVersion = _.get(clientState, CLIENT_STATE_KEYS.version);
    if (clientStateVersion !== CLIENT_STATE_VERSIONS.V2dot1) {
        throw new Error(`incompatible client state received in chart upgrade path for v2.1 to v2.2 with version no:${clientStateVersion}`);
    }
    return upgradeV2dot1toV2dot2(clientState, vizModel);
};
const testHooks = {
    upgradeV2dot1toV2dot2,
    DEPRECATED_CHART_RESPONSIVE_LAYOUT,
};
export { upgraderFn, testHooks };
//# sourceMappingURL=v2dot1-to-v2dot2.js.map